import React from 'react';
import './pageWithFooter.css';

/**
 * Coloca el contenido principal dentro del contenedor (p. ej. Grid)
 * y el footer fuera, a ancho completo de la pantalla.
 */
const PageWithFooter = ({ className, children, footer }) => (
    <div className={['page-with-footer', className].filter(Boolean).join(' ')}>
        <div className="page-with-footer__main">{children}</div>
        {footer}
    </div>
);

export default PageWithFooter;
